import { useMutation } from '@apollo/client';
import { t } from '@lingui/macro';
import { useToast } from '@pocketlaw/tetris';
import { EDIT_KEY } from './mutation';
export function useEditKey() {
    const { addToast } = useToast();
    const [mutate, { loading, error, data, reset }] = useMutation(EDIT_KEY, {
        onCompleted: () => {
            addToast({
                title: t({
                    message: 'Successfully edited API key',
                    comment: 'Success message when editing API key succeeds',
                }),
                appearance: 'success',
            });
        },
        onError: () => {
            addToast({
                title: t({
                    message: 'Failed to edit API key',
                    comment: 'Error message when editing API key fails',
                }),
                appearance: 'danger',
            });
        },
    });
    const editKey = (options) => mutate({ variables: options });
    return { editKey, data: data === null || data === void 0 ? void 0 : data.updateWebApiClient, loading, error, reset };
}
